export default `
    <section id="#: data.id#" class= "pop-up-left-column #: data.classes || "" #" >
        #= data.components #
    </section>
`;
